module.exports = __webpack_public_path__ + "img/information-line.3c5f7c8b.svg";